export default __webpack_public_path__ + "fonts/Hexicon-Regular.woff";